<!--
* UI Name: View Process
* PIC: 213960
* Modify Date: 2023/01/22
-->
<template>
  <v-card
    class="v-modal-new-window analyzed-dialog analyzed-view-dialog process-detail-panel process-list-container"
  >
    <!-- [S]  Popup title-->
    <v-card-title class="headline white--text" primary-title>
      {{ title }}
    </v-card-title>
    <!-- [S]  Section detail-->
    <v-card-text class="user-data-section">
      <v-form ref="form">
        <!-- //04/09/2021 203737 SPKA-63 issue 34 Modify the alignment of the text field and combo box for workflow -->
        <v-row class="ma-0">
          <v-col class="custom-form-control custom-figma-1 pb-0 pt-0 mt-0 pr-0" cols="12" lg="12">
            <v-row>
              <v-col
                class="comm-header-col data-query-section custom-figma-1 pb-0 pt-0 mt-0"
                cols="12"
                lg="5"
                md="5"
              >
                <v-row class="comm-header-col data-query-section pb-0 pt-0 custom-figma-1">
                  <v-col cols="12" sm="5" class="pb-0 pt-0 pl-0">
                    <div class="pl-0 pt-0 pb-0">
                      <v-text-field
                        v-model="formData.procNm"
                        :disabled="isHistory"
                        :label="$t('lbl.processSetup.addProcess.findbyName')"
                        ref="procNm"
                        dense
                        filled
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col
                    v-show="$cookies.get('user-admin-yn') === 'Y'"
                    cols="12"
                    sm="4"
                    class="pt-0"
                  >
                    <div class="pl-0 pt-0 pb-0">
                      <v-autocomplete
                        v-model="formData.compId"
                        :menu-props="{ offsetY: true }"
                        :items="compList"
                        :disabled="isHistory"
                        :label="$t('lbl.common.conditionSearch.selectCompany')"
                        ref="compId"
                        dense
                        filled
                      ></v-autocomplete>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="3" class="pt-0">
                    <div class="pl-0 pt-0 pb-0">
                      <v-autocomplete
                        v-model="formData.procDirCd"
                        :menu-props="{ offsetY: true }"
                        :items="boundList"
                        :disabled="isHistory"
                        :label="$t('lbl.common.conditionSearch.selectDirection')"
                        ref="procDirCd"
                        dense
                        filled
                      ></v-autocomplete>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                class="comm-header-col data-query-section custom-figma-1 pb-0 pt-0 mt-0"
                cols="12"
                lg="3"
                md="3"
              >
                <v-row>
                  <v-col cols="12" sm="6" class="pt-0" style="display: inline-flex; width: 100%">
                    <div class="pl-0 pt-0 pb-0">
                      <v-autocomplete
                        v-model="formData.senderId"
                        :menu-props="{ offsetY: true }"
                        :items="getPrnrList"
                        :disabled="isHistory"
                        :label="$t('lbl.common.conditionSearch.selectSender')"
                        ref="senderId"
                        dense
                        filled
                      ></v-autocomplete>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" class="pt-0" style="display: inline-flex; width: 100%">
                    <div class="pl-0 pt-0 pb-0">
                      <v-autocomplete
                        v-model="selSenderId"
                        :items="senderEdiIdList"
                        :label="$t('lbl.common.conditionSearch.selectSenderEDIID')"
                        :disabled="isHistory"
                        ref="selSenderId"
                        filled
                        dense
                        item-text="srIdQlfr"
                        item-value="id"
                        return-object
                      ></v-autocomplete>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                class="comm-header-col data-query-section custom-figma-1 pb-0 pt-0 mt-0"
                cols="12"
                lg="3"
                md="3"
              >
                <v-row>
                  <v-col cols="12" sm="6" class="pt-0" style="display: inline-flex; width: 100%">
                    <div class="pl-0 pt-0 pb-0">
                      <v-autocomplete
                        v-model="formData.receiverId"
                        :menu-props="{ offsetY: true }"
                        :items="getPrnrList"
                        :disabled="isHistory"
                        :label="$t('lbl.common.conditionSearch.selectReceiver')"
                        ref="receiverId"
                        dense
                        filled
                      ></v-autocomplete>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" class="pt-0" style="display: inline-flex; width: 100%">
                    <div class="pl-0 pt-0 pb-0">
                      <v-autocomplete
                        v-model="selReceiverId"
                        :items="receiverEdiIdList"
                        :label="$t('lbl.common.conditionSearch.selectReceiverEDIID')"
                        :disabled="isHistory"
                        ref="selReceiverId"
                        dense
                        filled
                        item-text="srIdQlfr"
                        item-value="id"
                        return-object
                      ></v-autocomplete>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <!-- <v-col
            class="text-right pt-0 pb-0"
            cols="12"
            lg="12"
          >
            <div class="pl-0 pt-0 pb-0" style="padding-right: 402px">
              <a class="underline" @click="openAddIdByMapper">{{ $t("lbl.processSetup.addProcess.addIdByMapper") }}</a>
            </div>
          </v-col> -->
        </v-row>
        <v-row> </v-row>
        <div class="d-flex">
          <div class="proc-icon-container">
            <v-tooltip v-if="authCompList.COM.manage" right content-class="tooltip-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="isHistory"
                  class="mb-1 mr-1 proc-button-style proc-comm drag-drawflow"
                  x-small
                  height="30"
                  width="30"
                  color="proc darken-1"
                  draggable="true"
                  v-on="on"
                >
                  <icon-svg :disabled="isHistory" :size="procIconSize" iconName="proc-comm" />
                </v-btn>
              </template>
              <span>Connector</span>
            </v-tooltip>
            <v-tooltip v-if="authCompList.FLT.manage" right content-class="tooltip-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="isHistory"
                  class="mb-1 mr-1 proc-button-style proc-filter"
                  x-small
                  color="proc darken-1"
                  height="30"
                  width="30"
                  draggable="true"
                  v-on="on"
                >
                  <icon-svg :disabled="isHistory" :size="procIconSize" iconName="proc-filter" />
                </v-btn>
              </template>
              <span>Filter</span>
            </v-tooltip>
            <v-tooltip right content-class="tooltip-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="isHistory"
                  class="mb-1 mr-1 proc-button-style proc-folder"
                  x-small
                  color="proc darken-1"
                  height="30"
                  width="30"
                  ref="btnAddDir"
                  draggable="true"
                  v-on="on"
                >
                  <icon-svg :disabled="isHistory" :size="procIconSize" iconName="proc-folder" />
                </v-btn>
              </template>
              <span>System Folder</span>
            </v-tooltip>
            <v-tooltip v-if="authCompList.DIR.manage" right content-class="tooltip-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="isHistory"
                  class="mb-1 mr-1 proc-button-style proc-folder"
                  x-small
                  color="proc darken-1"
                  height="30"
                  width="30"
                  ref="btnAddDir"
                  draggable="true"
                  v-on="on"
                >
                  <icon-svg :disabled="isHistory" :size="procIconSize" iconName="proc-folder" />
                </v-btn>
              </template>
              <span>Folder</span>
            </v-tooltip>
            <v-tooltip v-if="authCompList.MAP.manage" right content-class="tooltip-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="isHistory"
                  class="mb-1 mr-1 proc-button-style proc-mapper"
                  x-small
                  color="proc darken-1"
                  height="30"
                  width="30"
                  ref="btnAddMap"
                  draggable="true"
                  v-on="on"
                >
                  <icon-svg :disabled="isHistory" :size="procIconSize" iconName="proc-mapper" />
                </v-btn>
              </template>
              <span>Mapper</span>
            </v-tooltip>
            <v-tooltip v-if="authCompList.CVT.manage" right content-class="tooltip-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="isHistory"
                  class="mb-1 mr-1 proc-button-style proc-converter"
                  x-small
                  color="proc darken-1"
                  height="30"
                  width="30"
                  draggable="true"
                  v-on="on"
                >
                  <icon-svg :disabled="isHistory" :size="procIconSize" iconName="proc-converter" />
                </v-btn>
              </template>
              <span>Converter</span>
            </v-tooltip>
            <v-tooltip v-if="authCompList.USR.manage" right content-class="tooltip-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="isHistory"
                  class="mb-1 mr-1 proc-button-style proc-ucr"
                  x-small
                  color="proc darken-1"
                  height="30"
                  width="30"
                  draggable="true"
                  v-on="on"
                >
                  <icon-svg :disabled="isHistory" :size="procIconSize" iconName="proc-usr" />
                </v-btn>
              </template>
              <span>User</span>
            </v-tooltip>
            <v-tooltip right content-class="tooltip-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="isHistory"
                  class="mb-1 mr-1 proc-button-style proc-ucr"
                  x-small
                  color="proc darken-1"
                  height="30"
                  width="30"
                  draggable="true"
                  v-on="on"
                >
                  <icon-svg :disabled="isHistory" :size="procIconSize" iconName="proc-trigger" />
                </v-btn>
              </template>
              <span>Trigger</span>
            </v-tooltip>
            <v-tooltip v-if="authCompList.GRP.manage" right content-class="tooltip-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="isHistory"
                  class="mb-1 mr-1 proc-button-style proc-ucr"
                  x-small
                  color="proc darken-1"
                  height="30"
                  width="30"
                  draggable="true"
                  v-on="on"
                >
                  <icon-svg :disabled="isHistory" :size="procIconSize" iconName="proc-group" />
                </v-btn>
              </template>
              <span>Group</span>
            </v-tooltip>
            <v-tooltip v-if="authCompList.DBA.manage" right content-class="tooltip-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="isAgent"
                  :disabled="isHistory"
                  class="mb-1 mr-1 proc-button-style proc-dsm"
                  x-small
                  height="30"
                  width="30"
                  color="proc darken-1"
                  draggable="true"
                  v-on="on"
                >
                  <icon-svg :disabled="isHistory" :size="procIconSize" iconName="proc-dsm" />
                </v-btn>
              </template>
              <span>DB Adapter</span>
            </v-tooltip>
            <v-tooltip v-if="authCompList.AI.manage" right content-class="tooltip-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="isHistory"
                  class="mb-1 mr-1 proc-button-style proc-ai"
                  x-small
                  color="proc darken-1"
                  height="30"
                  width="30"
                  s
                  draggable="true"
                  v-on="on"
                >
                  <icon-svg :disabled="isHistory" :size="procIconSize" iconName="proc-ai" />
                </v-btn>
              </template>
              <span>AI Client</span>
            </v-tooltip>
          </div>

          <div id="drawhistory">
            <div id="drawflow">
              <system-progress
                :sysloading="isLoading"
                :sysloadingTitle="sysloadingTitle"
              ></system-progress>
            </div>
          </div>
        </div>
        <!-- [E]  Section detail-->
        <!-- [S]  Button Control-->

        <!-- /**
           * 2021.08.11 203737 SPKA-183 issue 119 Change button function in Workflow Detail screen
        */-->
        <v-divider class="ml-0 mr-0 mt-4 mb-2 divder-popup" inset></v-divider>
        <v-row class="btn-form-control">
          <v-col cols="10" class="text-left pb-0 pt-0"></v-col>
          <v-col cols="2" class="text-right pb-0 pt-0">
            <v-btn class="btn btn-close btn-popup" @click="closeWindow('btn-close')">{{
              $t('btn.common.close')
            }}</v-btn>
          </v-col>
        </v-row>
        <!-- [E]  Button Control-->
      </v-form>
      <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
        <mapper-version-dialog
          v-if="dialog.type == 'mapperVersion'"
          :id="dialog.id"
          :ref="'dialog-' + dialog.id"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :reFreshList="refreshMapComp"
          :closeWFAndMoveMapBuilder="closeWFAndMoveMapBuilder"
          :versionList="flatFileVersionHistoryItem"
          :options="dialog.options"
          class="custom-dialog mapper-version"
        ></mapper-version-dialog>
        <communicationRightLayer
          ref="communicationRightLayer"
          v-if="dialog.type == 'communicationRightLayer'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :manage="authCompList.COM.manage"
          :options="dialog.options"
          :id="dialog.id"
          style="position: absolute;right:0;top:0;width:752px !important;"
        ></communicationRightLayer>
        <filterRightLayer
          ref="filterRightLayer"
          v-if="dialog.type == 'filterRightLayer'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :manage="authCompList.FLT.manage"
          :options="dialog.options"
          :id="dialog.id"
          style="position: absolute;right:0;top:0;width:520px !important; height: 100%"
        ></filterRightLayer>
        <mapperRightLayer
          ref="mapperRightLayer"
          v-if="dialog.type == 'mapperRightLayer'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :manage="authCompList.MAP.manage"
          :options="dialog.options"
          :id="dialog.id"
          style="position: absolute;right:0;top:0;width:752px !important;"
        ></mapperRightLayer>
        <triggerRightLayer
          ref="triggerRightLayer"
          v-if="dialog.type == 'triggerRightLayer'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :options="dialog.options"
          :id="dialog.id"
          style="position: absolute;right:0;top:0;width:520px !important; height: 100%"
        ></triggerRightLayer>
        <userRightLayer
          ref="userRightLayer"
          v-if="dialog.type == 'userRightLayer'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :manage="authCompList.USR.manage"
          :options="dialog.options"
          :id="dialog.id"
          style="position: absolute;right:0;top:0;width:520px !important; height: 100%"
        ></userRightLayer>
        <groupRightLayer
          ref="groupRightLayer"
          v-if="dialog.type == 'groupRightLayer'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :manage="authCompList.GRP.manage"
          :options="dialog.options"
          :id="dialog.id"
          style="position: absolute;right:0;top:0;width:520px !important; height: 100%"
        ></groupRightLayer>

        <folderRightLayer
          ref="folderRightLayer"
          v-if="dialog.type == 'folderRightLayer'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :manage="authCompList.DIR.manage"
          :options="dialog.options"
          @queryLeftList="queryLeftList()"
          :id="dialog.id"
          style="position: absolute;right:0;top:0;width:520px !important; height: 100%"
        ></folderRightLayer>
        <converterRightLayer
          ref="converterRightLayer"
          v-if="dialog.type == 'converterRightLayer'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :manage="authCompList.CVT.manage"
          :manageDBB="authCompList.DBB.manage"
          :options="dialog.options"
          :id="dialog.id"
          style="position: absolute;right:0;top:0;width:520px !important; height: 100%"
        ></converterRightLayer>
        <aiClientRightLayer
          ref="aiClientRightLayer"
          v-if="dialog.type == 'aiClientRightLayer'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :manage="authCompList.AI.manage"
          :options="dialog.options"
          :id="dialog.id"
          style="position: absolute;right:0;top:0;width:520px !important; height: 100%"
        ></aiClientRightLayer>
        <dbAdapterRightLayer
          ref="dbAdapterRightLayer"
          v-if="dialog.type == 'dbAdapterRightLayer'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :options="dialog.options"
          :id="dialog.id"
          style="position: absolute;right:0;top:0;width:752px !important; height: 100%"
        ></dbAdapterRightLayer>
        <dbCaptorDetail
          v-if="dialog.type == 'dbCaptorDetail'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :manage="authCompList.DBA.manage"
          :options="dialog.options"
          :id="dialog.id"
          style="position: absolute;top:50px;width:752px !important;"
        ></dbCaptorDetail>
        <flatFile-layout-list-dialog
          v-if="dialog.type == 'flatFileLayoutList'"
          :id="dialog.id"
          :ref="'dialog-' + dialog.id"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :selectFile="loadFlatFile"
          :fileSelected="flatFileName"
          :options="dialog.options"
          class="custom-dialog flatfile-layout-list"
        ></flatFile-layout-list-dialog>
        <mappingDefinition-list-dialog
          v-if="dialog.type == 'mappingDefinitionList'"
          :id="dialog.id"
          :ref="'dialog-' + dialog.id"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :selectMapFile="loadMappingDefinitionFile"
          :fileSelected="mappingDefinitionFileName"
          :options="dialog.options"
          class="custom-dialog flatfile-layout-list"
        ></mappingDefinition-list-dialog>
        <selectCodeList
          v-if="dialog.type == 'selectCodeList'"
          @selectCodeItem="selectCodeItem($event)"
          :id="dialog.id"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :options="dialog.options"
          class="maplist-layout-dialog mapbuilder-scanner-list codetable-list"
          ref="selectCodeList"
        ></selectCodeList>
      </div>
    </v-card-text>
    <!-- <addIDByMapperDialog
      :procList="arrProc"
      :mapperContracts="mappers"
      :senderList="listSender"
      :isHistory="isHistory"
      :recipientList="listRecipient"
      ref="addIDByMapperDialog"
    ></addIDByMapperDialog> -->
    <addIDByMapperIndividualDialog
      :isHistory="isHistory"
      :senderList="listSender"
      :recipientList="listRecipient"
      ref="addIDByMapperIndividualDialog"
    ></addIDByMapperIndividualDialog>
  </v-card>
</template>

<script>
import procComm from '@/vue-caas/views/processnew/component/IconCommunication.vue';
import procMapper from '@/vue-caas/views/processnew/component/IconMapper.vue';
import procFilter from '@/vue-caas/views/processnew/component/IconFilter.vue';
import procConverter from '@/vue-caas/views/processnew/component/IconConverter.vue';
import procDir from '@/vue-caas/views/processnew/component/IconDir.vue';
import procDirSystem from '@/vue-caas/views/processnew/component/IconDirSystem.vue';
import procDBAdapter from '@/vue-caas/views/processnew/component/IconDBAdapter.vue';
import procUser from '@/vue-caas/views/processnew/component/IconUser.vue';
import procTrig from '@/vue-caas/views/processnew/component/IconTrigger.vue';
import procWorkflowGrp from '@/vue-caas/views/processnew/component/IconGroup.vue';
import procAI from '@/vue-caas/views/processnew/component/IconAI.vue';
// import addIDByMapperDialog from "@/vue-caas/views/processnew/AddIDByMapperDialog.vue";
import addIDByMapperIndividualDialog from '@/vue-caas/views/processnew/component/AddIDByMapperIndividualDialog.vue';
// import { Drag, Drop } from "vue-drag-drop";
import { mapState } from 'vuex';
import validationUtils from '@/vue-caas/utils/validationUtils';
import Drawflow from 'drawflow';
import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import i18n from '@/locale';
import store from '@/store';
import styleDrawflow from 'drawflow/dist/drawflow.min.css'; // eslint-disable-line no-use-before-define
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import mapperVersionDialog from '@/vue-dlb/views/map/MapperVersionHistory.vue';

import $ from 'jquery';
// 2021.12.06 SPKA-304 svg icon
import IconSvg from '@/vue-caas/components/IconBase.vue';
import cfg from '@/vue-caas/config/config.js';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import communicationRightLayer from '@/vue-caas/views/processnew/rightlayer/CommunicationRightLayer.vue';
import filterRightLayer from '@/vue-caas/views/processnew/rightlayer/FilterRightLayer.vue';
import mapperRightLayer from '@/vue-caas/views/processnew/rightlayer/MapperRightLayer.vue';
import triggerRightLayer from '@/vue-caas/views/processnew/rightlayer/TriggerRightLayer.vue';
import userRightLayer from '@/vue-caas/views/processnew/rightlayer/UserRightLayer.vue';
import groupRightLayer from '@/vue-caas/views/processnew/rightlayer/GroupRightLayer.vue';
import folderRightLayer from '@/vue-caas/views/processnew/rightlayer/FolderRightLayer.vue';
import converterRightLayer from '@/vue-caas/views/processnew/rightlayer/ConverterRightLayer.vue';
import aiClientRightLayer from '@/vue-caas/views/processnew/rightlayer/AIClientRightLayer.vue';
import dbAdapterRightLayer from '@/vue-caas/views/processnew/rightlayer/DBAdapterRightLayer.vue';
import dbCaptorDetail from '@/vue-caas/views/processnew/rightlayer/DBCaptorDetail.vue';
import flatFileLayoutListDialog from '@/vue-dlb/views/srm/FlatfilelayoutList.vue';
import mappingDefinitionListDialog from '@/vue-dlb/views/map/MappingDefinitionList.vue';
import selectCodeList from '@/vue-dlb/views/commons/SelectCodeTable.vue';
import { openWindow } from '@/vue-dlb/utils/window-opener';
import router from '@/router/index.js';

export default {
  components: {
    mapperVersionDialog,
    IconSvg,
    SystemProgress,
    communicationRightLayer,
    filterRightLayer,
    mapperRightLayer,
    triggerRightLayer,
    userRightLayer,
    groupRightLayer,
    folderRightLayer,
    converterRightLayer,
    aiClientRightLayer,
    // addIDByMapperDialog,
    addIDByMapperIndividualDialog,
    dbAdapterRightLayer,
    dbCaptorDetail,
    flatFileLayoutListDialog,
    mappingDefinitionListDialog,
    selectCodeList,
  },
  procComm,
  procFilter,
  // procFolder,
  // procSet,
  procConverter,
  // procEnveloper,
  procMapper,
  procDir,
  procDirSystem,
  procDBAdapter,
  procUser,
  procTrig,
  procWorkflowGrp,
  procAI,
  // Drag,
  // Drop,
  name: 'process-detail-dialog',
  data() {
    return {
      prnrList: [],
      boundList: [
        { text: 'Inbound', value: 'I' },
        { text: 'Outbound', value: 'O' },
      ],
      editor: null,
      formData: {
        procId: '',
        procNm: '',
        compId: '',
        senderId: '',
        receiverId: '',
        procDirCd: '',
        procComList: [],
        selSenderId: '',
        selReceiverId: '',
        qlfrSenderEdiId: '',
        qlfrReceiverEdiId: '',
        comEdiNm: '',
        receiverEdiNm: '',
        senderEdiNm: '',
        comEdiId: '',
        senderEdiIdKey: '',
        receiverEdiIdKey: '',
      },
      senderEdiIdList: [],
      receiverEdiIdList: [],
      title: '',
      options: '',
      nodeId: '',
      arrProc: [],
      loadArrProc: [],
      selectedNode: '',
      mappers: [],
      senders: [],
      recipients: [],
      mapperContracts: [],
      listSender: [],
      listRecipient: [],
      selSenderId: {
        id: '',
      },
      selReceiverId: {
        id: '',
      },
      arrLayoutDialog: [],
      dialogs: [],
      dialogId: 1,
      typeWorkflow: '',
      isHistory: true,
      // 2021.10.19 203728 SPKA-224 list
      fltrTpCdList: [],
      cvtrTpCdList: [],
      aiTpCdList: [],
      protocolList: [],
      onSave: false,
      procIconSize: 16,
      isAgent: false,
      isLoading: true,
      nodesSelected: [],
      compTpNmList: [
        { text: 'Connector', value: 'COM' },
        { text: 'Filter', value: 'FLT' },
        { text: 'Folder', value: 'DIR' },
        { text: 'Mapper', value: 'MAP' },
        { text: 'Converter', value: 'CVT' },
        { text: 'AI Client', value: 'AI' },
        { text: 'User', value: 'USR' },
        { text: 'Trigger', value: 'TRIG' },
        { text: 'Group', value: 'GRP' },
        { text: 'DBAdapter', value: 'DBA' },
        { text: 'DBAdapter', value: 'DBAC' },
      ],
      rightLayerNmList: [
        { text: 'communicationRightLayer', value: 'COM' },
        { text: 'filterRightLayer', value: 'FLT' },
        { text: 'folderRightLayer', value: 'DIR' },
        { text: 'mapperRightLayer', value: 'MAP' },
        { text: 'converterRightLayer', value: 'CVT' },
        { text: 'aiClientRightLayer', value: 'AI' },
        { text: 'userRightLayer', value: 'USR' },
        { text: 'triggerRightLayer', value: 'TRIG' },
        { text: 'groupRightLayer', value: 'GRP' },
        { text: 'dbAdapterRightLayer', value: 'DBA' },
        { text: 'dbAdapterRightLayer', value: 'DBAC' },
      ],
      authCompList: {
        COM: { manage: false },
        FLT: { manage: false },
        DIR: { manage: false },
        MAP: { manage: false },
        CVT: { manage: false },
        AI: { manage: false },
        USR: { manage: false },
        TRIG: { manage: true },
        GRP: { manage: false },
        DBA: { manage: false },
        DBB: { manage: false },
      },
      flatFileName: '',
      mappingDefinitionFileName: '',
    };
  },

  // watch: {
  //   mappers: {
  //     handler: function (val, oldVal) {
  //       this.$refs.addIDByMapperDialog.mappers = this.mappers;
  //     },
  //     deep: true
  //   },
  //   arrProc: {
  //     handler: function (val, oldVal) {
  //       this.$refs.addIDByMapperDialog.arrProc = this.arrProc;
  //     },
  //     deep: true
  //   }
  // },

  computed: {
    getPrnrList() {
      return this.prnrList;
    },
    ...mapState('analysis', {
      fileViewWindowParam: 'fileViewWindowParam',
    }),
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
    communicationList() {
      return this.$store.getters.communicationSelectBoxList;
    },
    filterList() {
      return this.$store.getters.filterSelectBoxList;
    },
    converterList() {
      return this.$store.getters.converterSelectBoxList;
    },
    aiClientList() {
      return this.$store.getters.aiClientSelectBoxList;
    },
    dbAdapterListHaveChild() {
      return this.$store.getters.dataDBASelectBox;
    },
    dbAdapterList() {
      let data = [];
      this.$store.getters.dataDBASelectBox.forEach((tmpDba) => {
        if (tmpDba.dba_type !== 'D2D' || tmpDba.dba_id === tmpDba.dba_child_id) {
          data.push(tmpDba);
        }
      });
      return data;
    },
    userList() {
      return this.$store.getters.userComponentSelectBoxList;
    },
    triggerList() {
      return this.$store.getters.triggerSelectBoxList;
    },
    workflowGroupList() {
      return this.$store.getters.workflowGroupSelectBoxList;
    },
    dbBrokerSelectBoxList() {
      return this.$store.getters.dbBrokerSelectBoxList;
    },
    foldList() {
      let data = [];
      this.$store.getters.foldList.forEach((e) => {
        if (e.FOLD_PA_ID === '0000000000' && e.FOLD_NAME === 'SYSTEM_' + e.FOLD_ID) {
          // this.systemFoldList.push(e);
        } else {
          data.push(e);
        }
      });
      return data;
    },
    systemFoldList() {
      let data = [];
      this.$store.getters.foldList.forEach((e) => {
        if (e.FOLD_PA_ID === '0000000000' && e.FOLD_NAME === 'SYSTEM_' + e.FOLD_ID) {
          data.push(e);
        }
      });
      return data;
    },
    compList() {
      let compList = [];
      const tmpCompList = this.$store.getters.companiesForSetup;
      for (let i = 0; i < tmpCompList.length; i += 1) {
        const tmpComp = tmpCompList[i];
        const tmp = { text: tmpComp.compNm, value: tmpComp.compId };
        compList.push(tmp);
      }
      // if (this.$cookies.get('ownr-id') === this.$cookies.get('comp-id')) {
      //   compList.unshift({ text: '*', value: '*' });
      // }
      return compList;
    },
    ...mapState('map', {
      mapList: 'mapListSMLK',
    }),
  },
  async created() {
    const componentRouters = router.options.routes.filter((e) => e.meta && e.meta.compCd);
    const menuAuth = JSON.parse(this.$cookies.get('menu-auth'));
    componentRouters.forEach((route) => {
      const index = menuAuth.find((e) => e.h === route.path);
      if (index) {
        this.authCompList[route.meta.compCd].manage = index.m;
      }
    });
    this.$auth.manage = true;
    this.isAgent = cfg.isAgent;
    // 05/04/2021 203737 issue 48 SPKA-96 Modify to not change the lightn version when refresh
    if (this.$route.query.theme === 'Dark') {
      this.$vuetify.theme.dark = true;
    } else {
      this.$vuetify.theme.dark = false;
    }

    let param = this.fileViewWindowParam[this.$route.params.id];
    this.options = param['options'];
    this.title = param['type'] + ' WorkFlow';
    this.typeWorkflow = param['type'];

    this.fltrTpCdList = param['fltrTpCdList'];
    this.cvtrTpCdList = param['cvtrTpCdList'];
    this.aiTpCdList = param['aiTpCdList'];
    this.protocolList = param['protocolList'];

    EventBus.$on('set-comp-id', this.clickHandler);
    EventBus.$on('set-comp-info', this.emitComInfo);
    EventBus.$on('open-right-layer', this.openRightLayer);
    EventBus.$on('collapse', this.updateConnections);
    EventBus.$on('set-map-contract', this.setInfoContract);
    EventBus.$on('open-map-version', this.openMapperVersion);
    EventBus.$on('open-workflow-group-component', this.openWorkflowGroupView);

    EventBus.$on('create-dba-child', this.createDBAChild);
    EventBus.$on('openAddIDByMapperIndividualDialog', this.openAddIDByMapperIndividualDialog);
    EventBus.$on('openDBCaptorDetail', this.openDBCaptorDetail);
    EventBus.$on('openFlatFileLayoutList', this.openFlatFileLayoutList);
    EventBus.$on('openMappingDefinitionList', this.openMappingDefinitionList);
    EventBus.$on('openCodeTableDialog', this.openCodeTableDialog);
    await this.initialize();
  },
  destroyed() {
    EventBus.$on('set-comp-id', this.clickHandler);
    EventBus.$on('set-comp-info', this.emitComInfo);
    EventBus.$on('open-right-layer', this.openRightLayer);
    EventBus.$on('collapse', this.updateConnections);
    EventBus.$on('set-map-contract', this.setInfoContract);
    EventBus.$on('open-map-version', this.openMapperVersion);
    EventBus.$on('open-workflow-group-component', this.openWorkflowGroupView);

    EventBus.$on('create-dba-child', this.createDBAChild);
    EventBus.$on('openAddIDByMapperIndividualDialog', this.openAddIDByMapperIndividualDialog);
    EventBus.$on('openDBCaptorDetail', this.openDBCaptorDetail);
    EventBus.$on('openFlatFileLayoutList', this.openFlatFileLayoutList);
    EventBus.$on('openMappingDefinitionList', this.openMappingDefinitionList);
    EventBus.$on('openCodeTableDialog', this.openCodeTableDialog);
  },

  methods: {
    checkRightLayerDialog() {
      let check = false;
      let type = '';
      this.dialogs.forEach((val) => {
        this.rightLayerNmList.forEach((e) => {
          if (val.id === e.text + '_0') {
            check = true;
            type = e.text;
          }
        });
      });
      return { check, type };
    },
    openAddIDByMapperIndividualDialog(mapper, action) {
      if (action === 'change') {
        this.$refs.addIDByMapperIndividualDialog.mapper = mapper;
        return;
      }
      let addMapperId = document.querySelector('.add-mapper-id-individual');
      if (this.$refs.addIDByMapperIndividualDialog.mapper.nodeId === mapper.nodeId) {
        if (addMapperId.style.display == 'block') {
          addMapperId.style.display = 'none';
          return;
        }
      }
      if (addMapperId.style.display == 'block') {
        addMapperId.style.display = 'none';
      }
      addMapperId.style.top = this.editor.pos_y + 5 + 'px';
      addMapperId.style.left = this.editor.pos_x + 'px';
      addMapperId.style.display = 'block';

      this.$refs.addIDByMapperIndividualDialog.mapper = mapper;
    },
    openWorkflowGroupView(item) {
      const isHistory = true;
      const type = 'View';
      const params = {
        ROWID: item.procId.toString(),
        type: type,
        options: {
          dataValue: item.id,
          id: item.id.toString(),
          isHistory: isHistory,
          versionNo: item.verNo,
        },
      };
      const arrView = {
        item,
        type,
      };
      params.compList = this.compList;
      params.fltrTpCdList = this.fltrTpCdList;
      params.cvtrTpCdList = this.cvtrTpCdList;
      params.aiTpCdList = this.aiTpCdList;
      params.protocolList = this.protocolList;
      const url = `/process/workflowGroupView/${type}/${params.ROWID}`;
      const size = 'width=1800,height=930,left=60,top=20';
      openWindow({
        arrView,
        url: url,
        params,
        size: size,
      });
    },
    loadComponents() {
      const id = document.getElementById('drawflow');
      this.editor = new Drawflow(id, Vue);
      let self = this;
      this.editor.on('nodeCreated', function(id) {
        self.nodeId = id;
      });
      this.editor.on('nodeSelected', function(id) {
        self.selectedNode = id;
        $(`#node-${self.selectedNode}`).css({ 'z-index': '3' });
        $(`#node-${self.selectedNode}`).addClass('custom-border-drawflow_node');
      });
      this.editor.on('nodeUnselected', function() {
        $(`#node-${self.selectedNode}`).css({ 'z-index': '2' });
        $(`#node-${self.selectedNode}`).removeClass('custom-border-drawflow_node');
        self.selectedNode = '';
      });
      this.editor.start();
      this.editor.on('connectionCreated', function(obj) {
        if (this.isHistory)
          self.editor.removeSingleConnection(
            obj.output_id,
            obj.input_id,
            obj.output_class,
            obj.input_class,
          );
      });

      self.editor.on('click', (e) => {
        if (
          e.target.className === 'proc-comp-name' ||
          e.target.parentElement.className === 'proc-comp-name'
        ) {
          const id = e.target.id;
          const nodeId = id.substring(0, id.length - 5);
          $('.proc-component.v-card.v-sheet').each(function() {
            let comp = $(this)[0].__vue__.$parent;

            if (comp.nodeId === nodeId) {
              comp.openRightLayer();
              return;
            }
          });
        }
        if (e.target.id === 'drawflow' || e.target.parentElement.id === 'drawflow') {
          if (self.checkRightLayerDialog().check) {
            const type = self.checkRightLayerDialog().type;
            if (self.$refs[type][0]) {
              setTimeout(() => {
                self.$refs[type][0].closeComDialog();
              }, 300);
            }
          }
          document.querySelector('.add-mapper-id-individual').style.display = 'none';
        }
      });

      self.editor.on('mouseMove', ({ x, y }) => {
        if (self.editor.node_selected && self.editor.drag) {
          $('.cus-bg-dialog').addClass('hidden');
          document.querySelector('.add-mapper-id-individual').style.display = 'none';
        }
        if (self.editor.node_selected && !self.editor.drag) {
          $(`#${self.editor.node_selected.id}`).removeClass('cursor-move');
          $('.cus-bg-dialog').removeClass('hidden');
        }
        const nodes = document.querySelectorAll(`.drawflow-node`);
        nodes.forEach((node) => {
          node.addEventListener('mouseover', () => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const comp = $(this)[0].__vue__.$parent;
              const id = comp.$el.parentElement.parentElement.id;
              if (id == node.id) {
                comp.showClose = true;
              }
            });
          });
          node.addEventListener('mouseleave', () => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const comp = $(this)[0].__vue__.$parent;
              const id = comp.$el.parentElement.parentElement.id;
              comp.showClose = false;
            });
          });
        });
        // 2022.12.05 213960 change position of component name follow component position
        if (self.selectedNode) {
          const id = self.selectedNode;
          let element = document.getElementById(`node-${id}`),
            style = window.getComputedStyle(element),
            top = style.getPropertyValue('top'),
            left = style.getPropertyValue('left');
          let div = document.getElementById(`node-${id}-icon`);
          if (div && div.style) {
            div.style.top = parseInt(top.substring(0, top.length - 2)) + 53 + 'px';
            div.style.left = parseInt(left.substring(0, left.length - 2)) - 100 + 'px';
          }
        }
      });
    },
    async openRightLayer(data) {
      const type = this.rightLayerNmList.filter((e) => e.value === data.comTp)[0].text;
      let item = {
        ROWID: 0,
        data: data,
        isHistory: this.isHistory,
      };
      if (this.checkRightLayerDialog().check) {
        await EventBus.$emit('check-right-layer-change');
        if (this.checkRightLayerDialog().check) {
          return;
        }
        this.newDialog(item, type) - 1;
        return;
      }
      this.newDialog(item, type) - 1;
    },
    closeWFAndMoveMapBuilder(json) {
      this.closeWindow('move-mapbuilder' + json);
    },
    openMapperVersion(val) {
      let type = 'mapperVersion';
      let item = {
        ROWID: 0,
        data: val,
        action: 'mapbuilder',
      };
      this.flatFileVersionHistoryItem = val;
      let indexArrDialog = this.findDialog('mapperVersion_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openDBCaptorDetail(data) {
      let type = 'dbCaptorDetail';
      let item = data;
      let indexArrDialog = this.findDialog('dbCaptorDetail_0');
      if (indexArrDialog != null) {
        this.dialogs[indexArrDialog].options.item = item;
        return;
      }
      this.newDialog(item, type) - 1;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = {
        left: 30 * this.dialogId,
        top: 30 * this.dialogId + 20,
        item,
      };
      let companyId = '';
      switch (this.idenType) {
        case 0:
          companyId = this.formData.compId;
          break;
        case 1:
          companyId = 'C,' + this.formData.senderId;
          break;
        case 2:
          companyId = 'P,' + this.formData.receiverId;
          break;
      }
      return { id, name, type, options, companyId };
    },
    removeDialogPopup(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    updateConnections(id) {
      this.editor.updateConnectionNodes(id.nodeId);
    },
    clickHandler(data) {
      let id = parseInt(data.nodeId.split('-').pop());
      for (let i = 0; i < this.arrProc.length; i += 1) {
        let info = this.arrProc[i].nodeId;
        if (info === id) {
          this.arrProc[i].comId = data.comId;
          $(`#node-${this.arrProc[i].nodeId}`).removeClass('border-invalid');
          $(`#node-${this.arrProc[i].nodeId}`).addClass('custom-border');
        }
      }
      // this.$refs.addIDByMapperDialog.arrProc = this.arrProc;
      // 2022.12.05 213960 add/change component name
      const compTpNm = this.compTpNmList.filter((e) => e.value === data.comTp)[0].text;
      if (!document.getElementById(`${data.nodeId}-icon`)) {
        if (!data.nodeId) {
          return;
        }
        let element = document.getElementById(data.nodeId),
          style = window.getComputedStyle(element),
          top = style.getPropertyValue('top'),
          left = style.getPropertyValue('left');
        let div = document.createElement('div');
        div.id = `${data.nodeId}-icon`;
        div.className = 'proc-comp-name';
        div.style.top = parseInt(top.substring(0, top.length - 2)) + 53 + 'px';
        div.style.left = parseInt(left.substring(0, left.length - 2)) - 100 + 'px';
        div.style.cursor = 'pointer';
        let p = document.createElement('p');
        p.id = `${data.nodeId}-name`;
        if (!data.comId) {
          let name = document.createTextNode('Select ' + compTpNm + ' ..');
          p.appendChild(name);
          p.style.color = '#9AAAC3';
        } else {
          let name = document.createTextNode(data.comName);
          p.appendChild(name);
        }
        div.appendChild(p);
        element.after(div);
      } else {
        if (!data.comId) {
          $(`#${data.nodeId}-icon`).text('Select ' + compTpNm + ' ..');
          $(`#${data.nodeId}-icon`).css({ color: '#9AAAC3' });
        } else {
          $(`#${data.nodeId}-icon`).text(data.comName);
          $(`#${data.nodeId}-icon`).css({
            color: this.$vuetify.theme.dark ? '#FFFFFF' : '#000000',
          });
        }
      }
    },
    emitComInfo(data) {
      let id = parseInt(data.nodeId.split('-').pop());
      for (let i = 0; i < this.arrProc.length; i += 1) {
        let info = this.arrProc[i].nodeId;
        if (info === id) {
          this.arrProc[i].comInfo = data.info;
          return;
        }
      }
    },
    getPartnerList(data) {
      this.prnrList = [];
      this.prnrList.push({ text: '*', value: '*' });
      this.getSenderEdiId();
      this.getReceiverEdiId();
      // When company select != *
      if (this.formData.compId !== '*') {
        for (let i = 0; i < this.compList.length; i += 1) {
          if (this.compList[i].value === this.formData.compId) {
            this.prnrList.push(this.compList[i]);
          }
        }
        this.$store.dispatch('getPartnerUseList').then(() => {
          const tmpPrnrList = this.$store.getters.partnerUseList;
          for (let i = 0; i < tmpPrnrList.length; i += 1) {
            const tmpPrnr = tmpPrnrList[i];
            const tmp = { text: tmpPrnr.prnrNm, value: tmpPrnr.prnrId };
            this.prnrList.push(tmp);
          }
        });
      }
    },
    async initialize() {
      // 2021.10.19 203728 SPKA-224 call data once
      this.isLoading = true;
      let leftItems = {
        header: ['USER_ID'],
        data: [
          {
            USER_ID: this.$cookies.get('user-id'),
          },
        ],
      };
      this.$store.dispatch('queryFolderList', leftItems).then(() => {
        let data = this.$store.getters.foldList;
        this.systemFoldList = [];
        this.foldList = [];
        data.forEach((e) => {
          if (e.FOLD_PA_ID === '0000000000' && e.FOLD_NAME === 'SYSTEM_' + e.FOLD_ID) {
            this.systemFoldList.push(e);
          } else {
            this.foldList.push(e);
          }
        });
      });

      this.$store.dispatch('getDbBrokerList');

      // 2021.10.26 203728 SPKA-224 return data not get store
      this.$store.dispatch('getCvtrGrpList');

      this.$store.dispatch('getFilterSelectBoxList');

      this.$store.dispatch('getUserComponentSelectBoxList');

      this.$store.dispatch('getTriggerSelectBoxList');
      this.$store.dispatch('getWorkflowGroupSelectBoxList');

      // 2023.3.8 213979 SPKA-620 get data for DBA
      this.$store.dispatch('getDBAdapterList', {});
      this.getMapList();

      await this.$store.dispatch('getCommunicationSelectBoxList');

      await this.$store.dispatch('getCompanyListSetup');

      if (this.options.dataValue !== undefined) {
        this.$store.dispatch('getProcess', this.options.dataValue).then(async () => {
          const procInfo = this.$store.getters.process;
          this.formData = procInfo;
          this.formData.selSenderId = this.formData.selSenderEdiIdList;
          this.formData.selReceiverId = this.formData.selReceiverEdiIdList;

          const params = {
            procId: this.options.dataValue,
            hash: this.$cookies.get('hash'),
          };
          this.getPartnerList();
          await this.getSenderEdiId();
          await this.getReceiverEdiId();

          await this.$store
            .dispatch('getProcessDtlListNew', params)
            .then(() => {
              this.loadArrProc = this.$store.getters.processDtlList;
              console.log('loadArrProc', this.loadArrProc);
            })
            // 2122.03.29 SPKA-421 Add spinner when loading Workflow popup
            .then(() => {
              this.loadComponents();
              this.$nextTick(() => this.updateComponent());
              this.isLoading = false;
            });
        });
      }
    },
    registerComponent(componentType, componentId, nodeInfo, mapperContract, useSrInMap, subType) {
      const props = {
        comId: componentId,
        mapperContracts: mapperContract,
        listSender: this.listSender,
        listRecipient: this.listRecipient,
        listComId: this.arrProc,
        useSrInMap: useSrInMap,
        procDirCd: this.formData.procDirCd,
        isHistory: this.isHistory,
      };
      props.comId = componentId !== undefined ? componentId : '';

      const options = {
        store: store,
        i18n: i18n,
        vuetify: vuetify,
      };
      const procData = {
        comNm: '',
        comTp: componentType,
        comId: componentId,
        comInfo: '',
        nodeId: '',
        nodeInfo: nodeInfo,
      };
      // 2021.10.19 203728 SPKA-224 det data list
      switch (componentType) {
        case 'COM':
          procData.comNm = 'procComm';
          props.protocolList = this.protocolList;
          props.manage = this.authCompList.COM.manage;
          this.editor.registerNode(componentType, procComm, props, options);
          break;
        case 'MAP':
          procData.comNm = 'procMapper';
          props.manage = this.authCompList.MAP.manage;
          this.editor.registerNode(componentType, procMapper, props, options);
          break;
        case 'FLT':
          procData.comNm = 'procFilter';
          props.fltrTpCdList = this.fltrTpCdList;
          props.manage = this.authCompList.FLT.manage;
          this.editor.registerNode(componentType, procFilter, props, options);
          break;
        case 'CVT':
          procData.comNm = 'procConverter';
          props.cvtrTpCdList = this.cvtrTpCdList;
          props.manage = this.authCompList.CVT.manage;
          props.manageDBB = this.authCompList.DBB.manage;
          this.editor.registerNode(componentType, procConverter, props, options);
          break;
        case 'AI':
          props.aiTpCdList = this.aiTpCdList;
          props.manage = this.authCompList.AI.manage;
          this.editor.registerNode(componentType, procAI, props, options);
          procData.comNm = 'procAI';
          procData.comTp = 'AI';
          break;
        case 'DIR':
          procData.comNm = 'procDir';
          if (subType === 'SYSTEM') {
            this.editor.registerNode(componentType, procDirSystem, props, options);
          } else {
            props.manage = this.authCompList.DIR.manage;
            this.editor.registerNode(componentType, procDir, props, options);
          }
          break;
        case 'USR':
          procData.comNm = 'procUser';
          procData.comTp = 'USR';
          props.comTp = 'USR';
          props.setDisable = true;
          props.manage = this.authCompList.USR.manage;
          this.editor.registerNode(componentType, procUser, props, options);
          break;
        case 'TRIG':
          procData.comNm = 'procTrig';
          procData.comTp = 'TRIG';
          props.comTp = 'TRIG';
          props.setDisable = true;
          this.editor.registerNode(componentType, procTrig, props, options);
          break;
        case 'GRP':
          procData.comNm = 'procWorkflowGrp';
          procData.comTp = 'GRP';
          props.comTp = 'GRP';
          props.setDisable = true;
          props.manage = this.authCompList.GRP.manage;
          this.editor.registerNode(componentType, procWorkflowGrp, props, options);
          break;
        case 'DBA':
          procData.comNm = 'procDBAdapter';
          procData.nodeParent = nodeInfo.id;
          props.isDisable = true;
          props.manage = this.authCompList.DBA.manage;
          this.editor.registerNode(componentType, procDBAdapter, props, options);
          break;
        case 'DBAC':
          procData.comNm = 'procDBAdapterChild';
          procData.comTp = 'DBAC';
          procData.nodeParent = nodeInfo.data.nodeParent;
          props.isDisable = true;
          props.comId = componentId;
          props.comTp = 'DBAC';
          props.manage = this.authCompList.DBA.manage;
          this.editor.registerNode(componentType, procDBAdapter, props, options);
          break;
      }

      procData.nodeId = nodeInfo.id;
      this.arrProc.push(procData);
    },
    /* 203665 Load component saved in db */
    updateComponent() {
      /**
       * 2021.07.06 203737 SPKA-150 issue 98 Fix the no. 5. Start with DIR in "CLT_TestCase" sheet
       */
      if (this.loadArrProc.length > 0) {
        this.arrProc = [];
        let data = { drawflow: { Home: { data: {} } } };
        let number = 0;
        this.loadArrProc.map((e, i) => {
          let dta = JSON.parse(e.nodeInfo);
          data.drawflow.Home.data[dta.id] = dta;
          if (e.comTp === 'DIR') {
            let indexDir = this.systemFoldList.findIndex((r) => r.FOLD_ID === e.comId);
            if (indexDir > -1) {
              e.subType = 'SYSTEM';
            }
          }
          this.registerComponent(
            e.comTp,
            e.comId,
            dta,
            e.mapper_contract,
            e.use_sr_in_map,
            e.subType,
          );
          this.editor.addNodeImport(dta, this.editor.precanvas);
          if (number < dta.id) number = dta.id;
        });
        this.editor.nodeId = number + 1;
        this.editor.drawflow = data;
        this.$nextTick(() => {
          Object.values(data.drawflow.Home.data).map((item) => {
            this.editor.updateConnectionNodes('node-' + item.id);
          });
        });
      }
    },
    async getSenderEdiId() {
      this.senderEdiIdList = [];
      this.listSender = [];
      const params = {
        prnrId: '',
        compId: '',
      };
      if (!this.formData.compId || !this.formData.senderId) return;
      const index = this.$store.getters.companiesForSetup.findIndex(
        (e) => e.compId === this.formData.senderId,
      );
      if (index !== -1) {
        params.compId = this.formData.senderId;
      } else {
        params.compId = this.formData.compId;
        params.prnrId = this.formData.senderId;
      }
      return this.$store.dispatch('getSenderEdiIdList', params).then(() => {
        if (this.$store.getters.senderEdiIdList.length > 0) {
          this.senderEdiIdList = this.$store.getters.senderEdiIdList;
          this.listSender = this.$store.getters.senderEdiIdList;
          let listSender = this.listSender;
          $('.proc-component.v-card.v-sheet').each(function() {
            let comp = $(this)[0].__vue__.$parent;
            let tp = comp.comTp;
            if (tp == 'MAP') comp.listSenderChange = listSender;
          });
          //   this.$refs.addIDByMapperDialog.listSender = listSender;
        }

        if (this.formData.senderEdiIdKey && this.selSenderId.id == '') {
          this.selSenderId.id = this.formData.senderEdiIdKey;
        }
        if (this.selSenderId.id && !this.formData.selSenderId) {
          let index = this.senderEdiIdList.findIndex((e) => e.id === this.selSenderId.id);
          if (index > -1) {
            this.formData.selSenderId = this.senderEdiIdList[index].srId;
          }
        }
      });
    },
    async getReceiverEdiId() {
      this.receiverEdiIdList = [];
      this.listRecipient = [];
      const params = {
        prnrId: '',
        compId: '',
      };
      if (!this.formData.compId || !this.formData.receiverId) return;
      const index = this.$store.getters.companiesForSetup.findIndex(
        (e) => e.compId === this.formData.receiverId,
      );
      if (index !== -1) {
        params.compId = this.formData.receiverId;
      } else {
        params.compId = this.formData.compId;
        params.prnrId = this.formData.receiverId;
      }
      return this.$store.dispatch('getReceiverEdiIdList', params).then(() => {
        if (this.$store.getters.receiverEdiIdList.length > 0) {
          this.receiverEdiIdList = this.$store.getters.receiverEdiIdList;
          this.listRecipient = this.$store.getters.receiverEdiIdList;
          let listRecipient = this.listRecipient;

          $('.proc-component.v-card.v-sheet').each(function() {
            let comp = $(this)[0].__vue__.$parent;
            let tp = comp.comTp;
            if (tp == 'MAP') comp.listRecipientChange = listRecipient;
          });
          // this.$refs.addIDByMapperDialog.listRecipient = listRecipient;
        }
        if (this.formData.receiverEdiIdKey && this.selReceiverId.id == '') {
          this.selReceiverId.id = this.formData.receiverEdiIdKey;
        }
        if (this.selReceiverId.id && !this.formData.selReceiverId) {
          let index = this.receiverEdiIdList.findIndex((e) => e.id === this.selReceiverId.id);
          if (index > -1) {
            this.formData.selReceiverId = this.receiverEdiIdList[index].srId;
          }
        }
      });
    },
    collapse(val) {
      $('.proc-component.v-card.v-sheet').each(function() {
        let comp = $(this)[0].__vue__.$parent;
        let tp = comp.comTp;
        if (tp != 'DIR') comp.collapse(val);
      });
    },
    // 203737 03/29/2021 Set info contract in SPKA-54
    setInfoContract(data) {
      let isInclude = false;
      if (this.mappers.length == 0) {
        this.mappers.push(data);
      } else {
        for (let i = 0; i < this.mappers.length; i++) {
          if (this.mappers[i].mapperId == data.mapperId) {
            isInclude = true;
            this.mappers[i].info = data.info;
            break;
          }
        }
        if (!isInclude) {
          this.mappers.push(data);
        }
      }
    },
    // 203737 03/29/2021 Get info mapper contract in SPKA-54
    getMapperContracts(data) {
      let obj, arr, isEquals, arrSender, arrReceiver, lenMap;
      for (let i = 0; i < data.length; i++) {
        arr = data[i].info;
        if (arr[0]) {
          obj = {
            mapper_id: '',
            sender_id: [],
            receiver_id: [],
            sequence: 1,
            use_sr_in_map: arr[0].isUseDifferentEDI,
            sender_nm: [],
            receiver_nm: [],
            sender_qual: [],
            receiver_qual: [],
          };
          for (let j = 0; j < arr.length; j++) {
            obj.sender_id.push(arr[j].sender.id);
            obj.receiver_id.push(arr[j].recipient.id);
            obj.sender_nm.push(arr[j].sender.srId);
            obj.receiver_nm.push(arr[j].recipient.srId);
          }
          obj.mapper_id = data[i].mapperId;
          if (this.mapperContracts.length == 0) {
            this.mapperContracts.push(obj);
          } else {
            isEquals = false;
            for (let j = 0; j < this.mapperContracts.length; j++) {
              arrSender = this.mapperContracts[j].sender_id;
              arrReceiver = this.mapperContracts[j].receiver_id;
              if (
                JSON.stringify(obj.sender_id) === JSON.stringify(arrSender) &&
                JSON.stringify(obj.receiver_id) === JSON.stringify(arrReceiver)
              ) {
                isEquals = true;
                obj.sequence = this.mapperContracts[j].sequence;
                this.mapperContracts.push(obj);
                break;
              }
            }
            this.mapperContracts.sort(function(a, b) {
              return a.sequence - b.sequence;
            });
            if (!isEquals) {
              lenMap = this.mapperContracts.length;
              obj.sequence = this.mapperContracts[lenMap - 1].sequence + 1;
              this.mapperContracts.push(obj);
            }
          }
        }
      }
    },
    closeWindow(type) {
      const message = {
        message: type,
      };
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(message, '*');
      }

      setTimeout(() => {
        window.close();
      }, 50);
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    openFlatFileLayoutList(rowItem) {
      let type = 'flatFileLayoutList';
      this.flatFileName = rowItem;
      let item = {
        ROWID: 0,
        readOnly: true,
      };
      let indexArrDialog = this.findDialog('flatFileLayoutList_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openMappingDefinitionList(rowItem) {
      let type = 'mappingDefinitionList';
      this.mappingDefinitionFileName = rowItem;
      let item = {
        ROWID: 0,
        readOnly: true,
      };
      let indexArrDialog = this.findDialog('mappingDefinitionList_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openCodeTableDialog(codeCtg) {
      let type = 'selectCodeList';
      let item = {
        ROWID: 0,
        codeCtg: codeCtg,
        readOnly: true,
      };
      let indexArrDialog = this.findDialog('selectCodeList_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    getMapList() {
      const masterSearchItems = {
        header: ['ADMIN_YN', 'CUST_ID'],
        data: [
          {
            ADMIN_YN: this.$cookies.get('user-admin-yn'),
            CUST_ID:
              this.$cookies.get('comp-id') === this.$cookies.get('ownr-id')
                ? this.$cookies.get('comp-id')
                : this.$cookies.get('ownr-id'),
          },
        ],
      };
      this.$store.dispatch('map/queryMapListByProcSetup', masterSearchItems);
    },
  },
  mounted() {
    window.addEventListener('storage', (event) => {
      if (event.key === 'processSharedData') {
        const updatedState = JSON.parse(event.newValue);
        let self = this;
        if (updatedState?.COM) {
          this.$store.dispatch('getCommunicationSelectBoxList').then(() => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const dataChange = self.$store.getters.communicationChange;
              if (
                Object.keys(dataChange).length > 0 &&
                (dataChange.update.length > 0 || dataChange.remove.length)
              ) {
                let comp = $(this)[0].__vue__.$parent;
                if (comp.comTp == 'COM') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex((e) => e.id == comp.formData.id);
                    if (index !== -1) {
                      comp.selectComm();
                      let indexArrDialog = self.findDialog('communicationRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.communicationRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex((e) => e.id == comp.formData.id);
                    if (index !== -1) {
                      comp.resetForm();
                      let indexArrDialog = self.findDialog('communicationRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.communicationRightLayer[0].closeComDialog();
                      }
                    }
                  }
                }
              }
            });
          });
        } else if (updatedState?.FLT) {
          this.$store.dispatch('getFilterSelectBoxList').then(() => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const dataChange = self.$store.getters.filterChange;
              if (
                Object.keys(dataChange).length > 0 &&
                (dataChange.update.length > 0 || dataChange.remove.length)
              ) {
                let comp = $(this)[0].__vue__.$parent;
                if (comp.comTp == 'FLT') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex(
                      (e) => e.fltrId == comp.formData.fltrId,
                    );
                    if (index !== -1) {
                      comp.selectFilter();
                      let indexArrDialog = self.findDialog('filterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.filterRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex(
                      (e) => e.fltrId == comp.formData.fltrId,
                    );
                    if (index !== -1) {
                      comp.resetForm();
                      let indexArrDialog = self.findDialog('filterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.filterRightLayer[0].closeComDialog();
                      }
                    }
                  }
                }
              }
            });
          });
        } else if (updatedState?.CVT) {
          this.$store.dispatch('getCvtrGrpList').then(() => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const dataChange = self.$store.getters.converterChange;
              if (
                Object.keys(dataChange).length > 0 &&
                (dataChange.update.length > 0 || dataChange.remove.length)
              ) {
                let comp = $(this)[0].__vue__.$parent;
                if (comp.comTp == 'CVT') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex(
                      (e) => e.cvtrId == comp.formData.cvtrId,
                    );
                    if (index !== -1) {
                      comp.selectConverter();
                      let indexArrDialog = self.findDialog('converterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.converterRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex(
                      (e) => e.cvtrId == comp.formData.cvtrId,
                    );
                    if (index !== -1) {
                      comp.resetForm();
                      let indexArrDialog = self.findDialog('converterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.converterRightLayer[0].closeComDialog();
                      }
                    }
                  }
                }
              }
            });
          });
        } else if (updatedState?.DBA) {
          this.$store.dispatch('getDBAdapterList').then(() => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const dataChange = self.$store.getters.dbAdapterChange;
              if (
                Object.keys(dataChange).length > 0 &&
                (dataChange.update.length > 0 || dataChange.remove.length)
              ) {
                let comp = $(this)[0].__vue__.$parent;
                if (comp.comTp == 'DBA') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex(
                      (e) => e.dba_child_id == comp.formData.dba_child_id,
                    );
                    if (index !== -1) {
                      comp.selectDBADetail();
                      let indexArrDialog = self.findDialog('dbAdapterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.dbAdapterRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex(
                      (e) => e.dba_child_id == comp.formData.dba_child_id,
                    );
                    if (index !== -1) {
                      comp.resetForm();
                      let indexArrDialog = self.findDialog('dbAdapterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.dbAdapterRightLayer[0].closeComDialog();
                      }
                    }
                  }
                } else if (comp.comTp == 'DBAC') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex(
                      (e) => e.dba_child_id == comp.formData.dba_child_id,
                    );
                    if (index !== -1) {
                      comp.selectDBADetail();
                      let indexArrDialog = self.findDialog('dbAdapterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.dbAdapterRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex(
                      (e) => e.dba_child_id == comp.formData.dba_child_id,
                    );
                    if (index !== -1) {
                      self.delNodeComponent(comp.nodeId);
                      let indexArrDialog = self.findDialog('dbAdapterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.dbAdapterRightLayer[0].closeComDialog();
                      }
                    }
                  }
                }
              }
            });
          });
        } else if (updatedState?.USR) {
          this.$store.dispatch('getUserComponentSelectBoxList').then(() => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const dataChange = self.$store.getters.userComponentChange;
              if (
                Object.keys(dataChange).length > 0 &&
                (dataChange.update.length > 0 || dataChange.remove.length)
              ) {
                let comp = $(this)[0].__vue__.$parent;
                if (comp.comTp == 'USR') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex((e) => e.uc_id == comp.formData.uc_id);
                    if (index !== -1) {
                      comp.selectUser();
                      let indexArrDialog = self.findDialog('userRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.userRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex((e) => e.uc_id == comp.formData.uc_id);
                    if (index !== -1) {
                      comp.resetForm();
                      let indexArrDialog = self.findDialog('userRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.userRightLayer[0].closeComDialog();
                      }
                    }
                  }
                }
              }
            });
          });
        } else if (updatedState?.GRP) {
          this.$store.dispatch('getWorkflowGroupSelectBoxList').then(() => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const dataChange = self.$store.getters.workflowGroupChange;
              if (
                Object.keys(dataChange).length > 0 &&
                (dataChange.update.length > 0 || dataChange.remove.length)
              ) {
                let comp = $(this)[0].__vue__.$parent;
                if (comp.comTp == 'GRP') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex((e) => e.id == comp.formData.id);
                    if (index !== -1) {
                      comp.selectWorkflowGroup();
                      let indexArrDialog = self.findDialog('groupRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.groupRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex((e) => e.id == comp.formData.id);
                    if (index !== -1) {
                      comp.resetForm();
                      let indexArrDialog = self.findDialog('groupRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.groupRightLayer[0].closeComDialog();
                      }
                    }
                  }
                }
              }
            });
          });
        } else if (updatedState?.MAP) {
          let masterSearchItems = {
            header: ['ADMIN_YN', 'CUST_ID'],
            data: [
              {
                ADMIN_YN: this.$cookies.get('user-admin-yn'),
                CUST_ID: this.$cookies.get('comp-id'),
              },
            ],
          };
          this.$store.dispatch('map/queryMapListByProcSetup', masterSearchItems).then(() => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const dataChange = self.mapChange;
              if (
                Object.keys(dataChange).length > 0 &&
                (dataChange.update.length > 0 || dataChange.remove.length)
              ) {
                let comp = $(this)[0].__vue__.$parent;
                if (comp.comTp == 'MAP') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex((e) => e.MAP_PRCS_NO == comp.mapperId);
                    if (index !== -1) {
                      comp.selectMap();
                      let indexArrDialog = self.findDialog('mapperRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.mapperRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex((e) => e.MAP_PRCS_NO == comp.mapperId);
                    if (index !== -1) {
                      comp.resetForm();
                      let indexArrDialog = self.findDialog('mapperRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.mapperRightLayer[0].closeComDialog();
                      }
                    }
                  }
                }
              }
            });
          });
        } else if (updatedState?.COMP) {
          this.$store.dispatch('getCompanyListSetup').then(() => {
            const dataChange = self.$store.getters.companyChange;
            if (Object.keys(dataChange).length > 0 && dataChange.remove.length > 0) {
              let index = dataChange.remove.findIndex((e) => e.value == this.formData.compId);
              if (index !== -1) {
                this.formData.compId = self.compList.filter((item) => item.value !== '*')[0].value;
              }
            }
          });
        } else if (updatedState?.PRNR) {
          const companyId = this.compList.filter((item) => item.value !== '*')[0].value;
          this.$store.dispatch('getPartnerUseList').then(() => {
            const dataChange = this.$store.getters.partnerChange;
            if (Object.keys(dataChange).length > 0) {
              if (dataChange.new.length > 0) {
                for (let i = 0; i < dataChange.new.length; i += 1) {
                  const tmpPrnr = dataChange.new[i];
                  const tmp = { text: tmpPrnr.prnrNm, value: tmpPrnr.prnrId };
                  this.prnrList.push(tmp);
                }
              } else if (dataChange.update.length > 0) {
                let indexSender = dataChange.update.findIndex(
                  (e) => e.prnrId == this.formData.senderId,
                );
                if (indexSender !== -1) {
                  this.formData.senderId = '';
                  this.getSenderEdiId();
                }
                let indexReceiver = dataChange.update.findIndex(
                  (e) => e.prnrId == this.formData.receiverId,
                );
                if (indexReceiver !== -1) {
                  this.formData.receiverId = '';
                  this.getReceiverEdiId();
                }
                for (let i = 0; i < dataChange.update.length; i += 1) {
                  const tmpPrnr = dataChange.update[i];
                  let index = this.prnrList.findIndex((e) => e.value == tmpPrnr.prnrId);
                  if (index !== -1) {
                    const tmp = {
                      text: tmpPrnr.prnrNm,
                      value: tmpPrnr.prnrId,
                    };
                    this.prnrList.splice(index, 1, tmp);
                  }
                }
              } else if (dataChange.remove.length > 0) {
                let indexSender = dataChange.remove.findIndex(
                  (e) => e.prnrId == this.formData.senderId,
                );
                if (indexSender !== -1) {
                  this.formData.senderId = '';
                  this.getSenderEdiId();
                }
                let indexReceiver = dataChange.remove.findIndex(
                  (e) => e.prnrId == this.formData.receiverId,
                );
                if (indexReceiver !== -1) {
                  this.formData.receiverId = '';
                  this.getReceiverEdiId();
                }
                for (let i = 0; i < dataChange.remove.length; i += 1) {
                  const tmpPrnr = dataChange.remove[i];
                  let index = this.prnrList.findIndex((e) => e.value == tmpPrnr.prnrId);
                  if (index !== -1) {
                    this.prnrList.splice(index, 1);
                  }
                }
              }
            }
          });
        } else if (updatedState?.EDI) {
          const senderParams = {
            prnrId: this.formData.senderId,
            compId: this.formData.compId,
          };
          this.$store.dispatch('getSenderEdiIdList', senderParams).then(() => {
            const dataChange = this.$store.getters.senderEdiIdChange;
            if (Object.keys(dataChange).length > 0) {
              this.getSenderEdiId();
            }
          });
          const receiverParams = {
            prnrId: this.formData.receiverId,
            compId: this.formData.compId,
          };
          this.$store.dispatch('getReceiverEdiIdList', receiverParams).then(() => {
            const dataChange = this.$store.getters.receiverEdiIdChange;
            if (Object.keys(dataChange).length > 0) {
              this.getReceiverEdiId();
            }
          });
        }
      }
    });
  },
};
</script>
